import { gql } from '@apollo/client';

// se usa para obtener el listado de post de una seccion por la categoria (blog, press, events, etc.)
const GET_POST_LIST = gql` 
  query GetSectionBySlug($slug: String!, $categoryName: String, $numPosts: Int!, $lang: String) {
    sectionsBy(slug: $slug) {
      postlist {
        tituloPl
      }
    }
    posts(last: $numPosts, where: {categoryName: $categoryName, language: $lang}) {
      nodes {
        title
        slug
        content
        featuredImage {
          node {
            mediaItemUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
      }
    }
  }
`;

export { GET_POST_LIST }